import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const AppLayout: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <div className="app-shell">
      <header className="app-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img 
            src="/hitachi.png" 
            alt="Hitachi" 
            style={{ 
              height: '40px', 
              width: 'auto',
              borderRadius: '6px'
            }} 
          />
          <div>
            <h1>工作面板</h1>
            <p className="app-subtitle">店鋪工作及服務紀錄</p>
          </div>
        </div>
        <div className="app-user">
          <span>{user?.name}</span>
          <button onClick={logout} className="btn-secondary">
            登出
          </button>
        </div>
      </header>

      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AppLayout;

